/**
 * QZ Tray Initialization
 * Auto-initialize QZ Tray when the app loads (async, non-blocking).
 * Falls back to Browser Print if QZ Tray is not installed/running.
 */

import * as GlobalService from "./global_services";

import("./services/qz-tray.service.js")
  .then((qzTrayService) => {
    qzTrayService
      .connectToQZ({ retries: 5, retryDelay: 1000 })
      .then(() => {
        GlobalService.setQzTrayConnected(true);

        const zplPrinter = qzTrayService.getDefaultZplPrinter();
        const pdfPrinter = qzTrayService.getDefaultPdfPrinter();
        const printerSummary =
          zplPrinter && pdfPrinter
            ? `${zplPrinter}, ${pdfPrinter}`
            : "Not configured";

        console.log(
          "%c[QZ Tray Init] Connected. Printers: " + printerSummary,
          "color: #4CAF50; font-weight: bold"
        );

        if (!zplPrinter || !pdfPrinter) {
          console.warn(
            "[QZ Tray Init] Configure printers in Printer Settings"
          );
        }
      })
      .catch(() => {
        console.log(
          "[QZ Tray Init] Not detected - will use Browser Print"
        );
        GlobalService.setQzTrayConnected(false);
      });
  })
  .catch((error) => {
    console.error("[QZ Tray Init] Failed to load service:", error?.message || error);
    GlobalService.setQzTrayConnected(false);
  });

window.loadQzTrayService = () => import("./services/qz-tray.service.js");

const qzTrayInit = {};
export default qzTrayInit;
